module.exports = {
    primary: '#3ac3b3',
    secondary: '#031732',
    danger: '#DF382C',
    warning: '#EFB73E',
    success: '#38B44A',
    gray: '#495057',
    info: '#30B1FFFF',
    darkGray: '#333333',
    lightGray: '#868e96',
    white: '#ffffff',
    blue: '#007bff',
    dark: '#343A40FF',
    light: '#EEEEEE',
    textlight: '#adb5bd',
}